import React from "react";
import styled, { keyframes } from "styled-components";

// 좌우 스크롤 애니메이션 정의
const scrollAnimation = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
`;

// 역방향 스크롤 애니메이션 추가
const scrollAnimationReverse = keyframes`
  0% { transform: translateX(-50%); }
  100% { transform: translateX(0); }
`;

// 새로운 색상 팔레트 (대략적인 값)
const darkGray = "#222222";
const goldAccent = "#a98e5d";
const lightGrayText = "#f0f0f0";
const subtleGrayText = "#bbbbbb"; // 브랜드 텍스트용으로 좀 더 밝은 회색

// 전체 랜딩 섹션 컨테이너 스타일 (padding 유지 또는 원복 가능)
const LandingContainer = styled.div`
  padding: 40px 20px; // 상하 패딩 조정
  text-align: center;
  background-color: ${darkGray};
  border-radius: 8px;
  margin-bottom: 30px;
  overflow: hidden;
`;

// 중앙 메시지 스타일 (원래 h1 스타일로 복구)
const CentralMessage = styled.h1`
  font-size: 1.4em; // 400px 너비에 맞춰 폰트 크기 조정
  font-weight: 600;
  color: ${lightGrayText};
  margin-bottom: 30px; // 하단 마진 조정
  line-height: 1.4;

  /* @media (max-width: 768px) {
    font-size: 1.5em;
  } */ // 이 미디어 쿼리는 PageContainer의 max-width: 400px에 의해 이미 포괄되므로 주석 처리 또는 삭제
`;

// 스크롤되는 브랜드 영역 컨테이너
const ScrollingBrandsContainer = styled.div`
  width: 100%;
  overflow: hidden;
  position: relative;
  margin-bottom: 15px; // 각 줄 사이의 간격

  /* 좌우 그라데이션 효과 */
  &::before,
  &::after {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    width: 50px;
    z-index: 2;
  }
  &::before {
    left: 0;
    background: linear-gradient(to right, ${darkGray}, rgba(34, 34, 34, 0));
  }
  &::after {
    right: 0;
    background: linear-gradient(to left, ${darkGray}, rgba(34, 34, 34, 0));
  }
`;

// 실제로 스크롤될 브랜드들을 감싸는 래퍼
const ScrollingWrapper = styled.div`
  display: flex;
  width: fit-content;
  animation: ${(props) => props.animation || scrollAnimation} 60s linear
    infinite; // 속도 60초 유지
  white-space: nowrap;

  &:hover {
    animation-play-state: paused;
  }
`;

// 개별 브랜드 아이템 스타일 (span 사용) - BrandLogo 대신 BrandItem으로 변경
const BrandItem = styled.span`
  font-size: 1.1em; // 텍스트 크기 조정
  font-weight: 500;
  color: ${subtleGrayText}; // 약간 밝은 회색 텍스트
  padding: 0 25px; // 브랜드 사이 간격
  display: inline-block;
  line-height: 1.5;

  @media (max-width: 768px) {
    font-size: 1em;
    padding: 0 15px;
  }
`;

// 브랜드 리스트 (텍스트 배열로 복구)
const brandsRow1 = [
  "카발란 (Kavalan)",
  "키엘 (Kiehl's)",
  "에스티 로더 (Estée Lauder)",
  "조니워커 (Johnnie Walker)",
  "라메르 (La Mer)",
];

const brandsRow2 = [
  "구찌 (Gucci)",
  "발렌타인 (Ballantine's)",
  "설화수 (Sulwhasoo)",
  "정관장",
  "스와로브스키 (Swarovski)",
];

export const LandingSection = () => {
  return (
    <LandingContainer>
      {/* 중앙 메시지 내용 원복 */}
      <CentralMessage>
        원하는 면세점 상품을 찾아주세요.
        <br />
        <br />
        5분 내로 최저가 상품을 찾아드립니다.
      </CentralMessage>

      {/* --- 브랜드 캐러셀 (제목 다음에 위치) --- */}
      <ScrollingBrandsContainer>
        <ScrollingWrapper animation={scrollAnimation}>
          {[...brandsRow1, ...brandsRow1].map((brand, index) => (
            <BrandItem key={`row1-${brand}-${index}`}>{brand}</BrandItem>
          ))}
        </ScrollingWrapper>
      </ScrollingBrandsContainer>
      <ScrollingBrandsContainer>
        <ScrollingWrapper animation={scrollAnimationReverse}>
          {[...brandsRow2, ...brandsRow2].map((brand, index) => (
            <BrandItem key={`row2-${brand}-${index}`}>{brand}</BrandItem>
          ))}
        </ScrollingWrapper>
      </ScrollingBrandsContainer>
    </LandingContainer>
  );
};
